import { useEffect, useState } from 'react'

export const useLoader = (callback, deps = []) => {
  let [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    let isActive = true

    const func = async () => {
      setIsLoading(true)
      await callback()

      if (isActive) {
        setIsLoading(false)
      }
    }

    func()

    return () => {
      isActive = false
    }
  }, deps) // eslint-disable-line react-hooks/exhaustive-deps

  return isLoading
}
